import { make as Provider } from "./provider/Auth__Provider.gen";

export const Auth = {
  Provider,
};
